<section class="header" id="{{title | lowercase}}">
  <div class="content-wrapper">
    <h1>{{title}}</h1>
  </div>
</section>
